import React, { useEffect } from "react";
import * as R from "ramda";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { compose } from "recompose";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { notification } from "antd";

import { hydratedTeams } from "../../../store/selectors/team";
import { findTeam } from "../../../utils/teams";
import Nav from "../../../components/Nav";
import Analytics from "../../../scenes/Analytics";
import { FETCH_TEAMS } from "../../../store/actions/teams";
import { SELECT_TEAM, DESELECT_TEAM } from "../../../store/actions/team";

import Configuration from "./Configuration";
import Opportunities from "./Opportunities";
import TeamSkeleton from "./TeamSkeleton";

import styled from "styled-components/macro";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const Team = ({
  redirectToHome,
  match,
  team,
  loadingTeams,
  selectTeam,
  deselectTeam
}) => {
  const { t } = useTranslation(["global"]);

  useEffect(() => {
    if (team) {
      selectTeam(team);
    }
    return () => {
      deselectTeam();
    };
    // eslint-disable-next-line
  }, []);

  if (redirectToHome) {
    return <Redirect to="/" />;
  }

  if (loadingTeams) {
    return <TeamSkeleton />;
  }

  if (!team) {
    notification.error({
      message: t("toasts:team.notFoundTitle"),
      description: t("toasts:team.notFoundDescription")
    });
    return <Redirect to="/" />;
  }

  const baseLinkUrl = `/equipos/${match.params.teamId}`;

  return (
    <Container>
      {team.belongsToTeam && (
        <Nav
          path={match.url}
          links={[
            {
              testKey: "profile",
              to: `${baseLinkUrl}/oportunidades`,
              icon: "profile",
              label: t("global:opportunities")
            },
            {
              testKey: "setting",
              to: `${baseLinkUrl}/configuracion`,
              icon: "setting",
              label: t("global:configuration")
            },
            {
              testKey: "analytics",
              to: `${baseLinkUrl}/analytics`,
              icon: "line-chart",
              label: t("global:analytics")
            }
          ]}
        />
      )}
      <Switch>
        {team.belongsToTeam && (
          <Route
            exact
            path={`${baseLinkUrl}/configuracion`}
            render={props => <Configuration {...props} team={team} />}
          />
        )}
        <Route
          exact
          path={`${baseLinkUrl}/oportunidades`}
          render={props => (
            <Opportunities
              {...props}
              team={team}
              canCreate={team.belongsToTeam}
            />
          )}
        />
        <Route
          path={`${baseLinkUrl}/analytics`}
          render={() => <Analytics team={team} />}
        />
        <Redirect to={`${baseLinkUrl}/oportunidades`} />
      </Switch>
    </Container>
  );
};

export default compose(
  withRouter,
  connect(
    (state, { match }) => ({
      team: R.pipe(
        hydratedTeams,
        R.defaultTo([]),
        findTeam(R.path(["params", "teamId"], match))
      )(state),
      loadingTeams: !R.prop("teams", state),
      redirectToHome: FETCH_TEAMS.getStatus(state) === "rejected"
    }),
    {
      selectTeam: SELECT_TEAM.run,
      deselectTeam: DESELECT_TEAM.run
    }
  )
)(Team);
